window.OBSWidgetLocale = {
  id: "de-DE",
  decimalSeparator: ",",
  weekdays: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Sonnabend"
  ],
  monthNames: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ],
  states: {
    selectTreatment: "Behandlung wählen",
    selectDate: "Datum aussuchen",
    sendRequest: "Termin bestätigen"
  },
  headers: {
    selectSubsidiary: "Bitte wähle Deinen Standort",
    selectTreatment: "Bitte wähle Deine gewünschte Behandlung",
    selectDate: "Bitte wähle das gewünschte Datum",
    selectTime: "Bitte wähle die gewünschte Uhrzeit",
    sendRequest: "Bitte gib hier deine Kontaktdaten ein",
    completed: "Vielen Dank für Deine Buchung!",
    error: "Die Buchungs konnte leider nicht durchgeführt werden. Probiere es bitte noch einmal oder melde dich telefonisch bei uns, wenn es weiterhin nicht funktioniert."
  },
  withoutDate: "(ohne Datum)",
  withoutTime: "(ohne Zeitangabe)",
  salutations: [
    {
      id: 1,
      name: "Frau"
    },
    {
      id: 0,
      name: "Herr"
    },
    {
      id: 2,
      name: "Person"
    }
  ],
  salutation: "Anrede",
  firstName: "Vorname",
  lastName: "Nachname",
  address: "Anschrift",
  postalCode: "PLZ",
  city: "Ort",
  email: "E-Mail",
  phoneNumber: "Telefonnummer",
  memo: "Bemerkung",
  agreeToTerms: "Ich habe die {dppLink}AGB und Datenschutzerklärung{dppLinkEnd} gelesen und bin damit einverstanden, dass meine Daten zum Zwecke der Kontaktaufnahme und Abwicklung von Dienstleistungen gespeichert werden.",
  acceptOffers: "Ich möchte spezielle Angebote und Informationen erhalten.",
  submit: "Termin buchen",
  required: "Bitte {value} eingeben.",
  invalidEmail: "Bitte gibt eine gültige E-Mail-Adresse ein.",
  pleaseAccept: "Deine Zustimmung ist erforderlich.",
  subsidiary: "Standort",
  noProposals: "Keine Termine verfügbar. Bitte wählen Sie ein anderes Datum.",
  success: "Deine Buchung war erfolgreich. Bitte prüfe Deinen E-Mail Posteingang für die Bestätigung des Termins.",
  region: "Bereich",
  birthday: "Geburtsdatum",
  noData: "(bitte auswählen)",
  employee: "Mitarbeiter*in",
  anyEmployee: "(beliebig)",
  oClock: "Uhr",
  requestAlreadySent: "Deine Anfrage wurde bereits bearbeitet; bitte prüfe Dein E-Mail-Postfach. Um einen neuen Termin anzufragen, lade Sie die Seite neu.",
  selectionTitle: "Deine Auswahl",
  requiredFields: "* Erforderliche Angaben",
  dayPattern: "Tag",
  monthPattern: "Monat",
  yearPattern: "Jahr",
  numberOfPeople: "Personenanzahl",
  firstVisit: "Ich bin zum ersten Mal bei {companyName}",
  addTreatment: "Behandlung hinzufügen",
  removeTreatment: "Behandlung abwählen"
};